import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M10 6.6 8.6 8', key: 'itrr7k' }],
  ['path', { d: 'M12 18v4', key: 'jadmvz' }],
  ['path', { d: 'M15 7.5 9.5 13', key: '1vyrsv' }],
  ['path', { d: 'M7 22h10', key: '10w4w3' }],
  ['circle', { cx: '12', cy: '10', r: '8', key: '1gshiw' }],
];

/**
 * @component @name MirrorRound
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNi42IDguNiA4IiAvPgogIDxwYXRoIGQ9Ik0xMiAxOHY0IiAvPgogIDxwYXRoIGQ9Ik0xNSA3LjUgOS41IDEzIiAvPgogIDxwYXRoIGQ9Ik03IDIyaDEwIiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTAiIHI9IjgiIC8+Cjwvc3ZnPg==) - https://lucide.dev/icons/mirror-round
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MirrorRound = createLucideIcon('mirror-round', __iconNode);

export default MirrorRound;
